import client from "./client";
import { UserDetails } from "@lab/types/users";

const fetch = async (): Promise<UserDetails | undefined> => {
	const response = await client.get(`/dailydata/reports`);
	return response.data as UserDetails;
};

export { fetch };
